import './static/css/details.css';

const Details = () => {
     return (
          <div class="d-lg-flex details justify-content-center pe-5 pe-lg-0 ps-5 ps-lg-0">
               <div class="border-0 card col-lg-3 col-xl-2 px-2 px-lg-0 py-4 py-lg-0 shadow text-center">
                    <div class="card-body">
                         <i class="bi bi-arrow-repeat fs-1" />
                         <h5 class="card-title">
                              Atualiza&ccedil;&otilde;es constantes
                         </h5>
                         <p class="card-text">
                              Atualizamos constantemente nosso sistema para garantir inova&ccedil;&atilde;o e m&aacute;xima performance aos nossos clientes
                         </p>
                    </div>
               </div>

               <div class="d-lg-block d-sm-none px-3" />
               <div class="d-lg-none py-3" />

               <div class="border-0 card col-lg-3 col-xl-2 px-2 px-lg-0 py-4 py-lg-0 shadow text-center">
                    <div class="card-body">
                         <i class="bi bi-people-fill fs-1" />
                         <h5 class="card-title">
                              Suporte dedicado
                         </h5>
                         <p class="card-text">
                              Nossa equipe de suporte est&aacute; sempre dispon&iacute;vel para resolver suas d&uacute;vidas e garantir sua satisfa&ccedil;&atilde;o
                         </p>
                    </div>
               </div>

               <div class="d-lg-block d-sm-none px-3" />
               <div class="d-lg-none py-3" />

               <div class="border-0 card col-lg-3 col-xl-2 px-2 px-lg-0 py-4 py-lg-0 shadow text-center">
                    <div class="card-body">
                         <i class="bi bi-bell-fill fs-1" />
                         <h5 class="card-title">
                              Novidades
                         </h5>
                         <p class="card-text">
                              Estamos sempre lan&ccedil;ando recursos inovadores para melhorar sua experi&ecirc;ncia
                         </p>
                    </div>
               </div>
          </div>
     );
}

export default Details;